import React from "react";

import svg from "../../assets/images/icons/steps/Multi Output Step f.svg";

export const MultiStepIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Multi Step"}
    />
);
